import {
    OpeningMode,
    AppType,
    OpeningMethod,
    IntegrationMethod,
    ApplicationMode,
    UserMode,
} from '@sparkware/uc-sdk-core';
import { ISupportedLanguages } from './interfaces';

const enum IntegrationMethodNum {
    Div = 0,
    IFrame = 1,
}

const enum AppTypeNum {
    App = 0,
    Game = 1,
}

const enum OpeningMethodNum {
    UC = 0,
    GNP = 1,
}

const enum UserModeNum {
    Anonymous = 0,
    Authenticated = 1,
}

const enum OpeningModeNum {
    RightSideDrawer = 0,
    Popup = 1,
    PopupWindow = 2,
    FullScreenPopup = 3,
    InClient = 4,
    MainView = 5,
    Bubble = 6,
}

const enum ApplicationModeNum {
    Proxy = 0,
    Mini = 1,
    Full = 2,
}

const IntegrationMethodMap: Record<IntegrationMethodNum, IntegrationMethod> = {
    [IntegrationMethodNum.Div]: IntegrationMethod.Div,
    [IntegrationMethodNum.IFrame]: IntegrationMethod.IFrame,
};

const AppTypeMap: Record<AppTypeNum, AppType> = {
    [AppTypeNum.App]: AppType.App,
    [AppTypeNum.Game]: AppType.Game,
};

const OpeningMethodMap: Record<OpeningMethodNum, OpeningMethod> = {
    [OpeningMethodNum.UC]: OpeningMethod.UC,
    [OpeningMethodNum.GNP]: OpeningMethod.GNP,
};

const OpeningModeMap: Record<OpeningModeNum, OpeningMode> = {
    [OpeningModeNum.RightSideDrawer]: OpeningMode.rightSideDrawer,
    [OpeningModeNum.Popup]: OpeningMode.popup,
    [OpeningModeNum.PopupWindow]: OpeningMode.popupWindow,
    [OpeningModeNum.FullScreenPopup]: OpeningMode.fullScreenPopup,
    [OpeningModeNum.InClient]: OpeningMode.inClient,
    [OpeningModeNum.MainView]: OpeningMode.mainView,
    [OpeningModeNum.Bubble]: OpeningMode.bubble,
};

const ApplicationModeMap: Record<ApplicationModeNum, ApplicationMode> = {
    [ApplicationModeNum.Full]: ApplicationMode.Full,
    [ApplicationModeNum.Mini]: ApplicationMode.Mini,
    [ApplicationModeNum.Proxy]: ApplicationMode.Proxy,
};

const toCamelCase = (str: string) => str?.length && str[0].toLowerCase() + str.substring(1);

export const mapIntegrationMethod = (val: IntegrationMethodNum): IntegrationMethod =>
    IntegrationMethodMap[val];
export const mapAppType = (val: AppTypeNum): AppType => AppTypeMap[val];
export const mapOpeningMethod = (val: OpeningMethodNum): OpeningMethod => OpeningMethodMap[val];
export const mapOpeningMode = (val: OpeningModeNum): OpeningMode => OpeningModeMap[val];
export const mapApplicationMode = (val: ApplicationModeNum) => ApplicationModeMap[val];

export const mapUserMode = (supportedUserModes: UserModeNum[]): UserMode =>
    supportedUserModes.includes(UserModeNum.Anonymous)
        ? UserMode.Anonymous
        : UserMode.Authenticated;

export const mapTranslations = (
    translations: Record<string, { PageUrl: string; PageTitle: string }>,
): Record<string, ISupportedLanguages> => {
    if (!translations) {
        return null;
    }

    return Object.keys(translations).reduce((acc, lang) => {
        const tr = translations[lang];

        if (!tr) {
            return acc;
        }

        acc[lang] = {
            pageURL: translations[lang].PageUrl,
            pageTitle: translations[lang].PageTitle,
        };

        return acc;
    }, {} as Record<string, ISupportedLanguages>);
};

export const mapExtras = (extras: any) => {
    if (!extras || Array.isArray(extras) || typeof extras !== 'object') {
        return extras;
    }

    return Object.keys(extras).reduce((acc, key) => {
        acc[toCamelCase(key)] = extras[key];
        return acc;
    }, {});
};
